import React from 'react';
import TestChat from './testShell/TestChat';
import dass42 from './testShell/configs/dass42';

// DASS-42 in the chat, on the shared test shell (testShell/). Its words, scale and
// save calls live in testShell/configs/dass42.js.
const ChatbotDASS42 = (props) => <TestChat config={dass42} {...props} />;

export default ChatbotDASS42;
